// material-ui
import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';

const CustomButton = styled(Button)(({ theme }) => ({
    '&:disabled': {
        color: 'inherit',
        opacity: '0.5'
    }
}));

export default CustomButton;
